import axios from "./index";

export default {
  elasticsearchJournals(params, successCallback, failureCallback) {
    axios.post("/api/v1/journals/search", {
      query: params.query,
    })
      .then(response => {
        successCallback(response.data);
      })
      .catch(error => {
        failureCallback(error);
      });
  },
};
